// src/pages/seller/Seller2Net/components/ResultsModal.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { buildBuyerPayload } from "../../../../utils/payloadBuilder";
import { formatDateMDY } from "../../../../utils/format";
import { useModal } from "../../../../context/ModalContext";
import { useAuth, isGuestUser } from "../../../../context/AuthContext";
import {
  isOriginationRow,
  calcOriginationDollarValue,
  getOwnRowPercent,
} from "../../../../utils/originationFee";
import EmailModal from "../../popups/EmailModal";

export default function ResultsModal({
  step,
  setStep,
  onEditManual,
  formData,
  result,
  formatCurrency,
  cancelModal,
  handleSaveCalc,
  handleDownloadPrintPDF,
  getEffectiveFormData,
  cancelResultModal,
  showToaster,
}) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { openModal, closeModal, closeAllModals } = useModal();

  const handleClose = () => {
    setStep(1);
    closeModal();
    closeAllModals();
  };

  const handleExit = (e) => {
    e.preventDefault();
    closeAllModals();
    setTimeout(() => navigate("/dashboard"), 0);
  };

  const data = formData || {};

  /* ── Safely resolve origination-factor % → dollar cost ── */
  const getBuyerClosingCostValue = (item) => {
    if (!item) return "0.00";
    const unit = (item.unit || "").trim();

    if (isOriginationRow(item) && unit === "%") {
      return calcOriginationDollarValue(getOwnRowPercent(item), data.salesPrice);
    }
    return item.value || 0;
  };

  const getBuyerClosingCostUnit = (item) => {
    if (!item) return "$";
    const unit = (item.unit || "").trim();
    if (isOriginationRow(item) && unit === "%") return "$";
    return item.unit || "$";
  };

  return (
    <div className="popup-data-result model-popup-style">
      {step === 1 ? (
        <>
          <div className="model-body">
            <div className="heading-gp">
              <p className="heading-b">
                {data?.main_company_name || ""} Calculator has calculated that
                on a <b className="txtclr">$ {data?.salesPrice || "0.00"}</b>{" "}
                Estimated Appraised Value, <br />
                the{" "}
                {data?.totalClosingMeta?.totalInvestmentText ||
                  "Cash To Borrower"}{" "}
                for the refinance will be{" "}
                <b
                  className={`txtclr ${(data?.totalClosingMeta?.totalInvestment ?? 0) < 0 ? "text-red-600" : ""}`}
                >
                  {" "}
                  $ {formatCurrency(data?.totalClosingMeta?.totalInvestment)}
                </b>{" "}
                based upon the information you provided.
              </p>
            </div>

            <div className="tbl-top-details top-tbl-mrgn">
              <table>
                <tbody>
                  <tr>
                    <td className="txt-left heading-e txtclr">
                      <span className="clrbody">Prepared for:</span>{" "}
                      {data?.preparedFor || "New Client"},{" "}
                      {data?.addressMeta?.address || ""}
                    </td>
                    <td className="txt-right heading-e txtclr">
                      <span className="clrbody">Closing County Office:</span>{" "}
                      {data?.addressMeta?.county || "N/A"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="tbl-type-a popup-tbl-td-width">
              <h3>
                Refinance's -{" "}
                {data.loanInfoMeta?.buyersLoanType || "Conventional"} Loan at{" "}
                {data.loanInfoMeta?.interestRate1 || "0.00"} % Interest
              </h3>
              <table cellPadding="0" cellSpacing="0">
                <tbody>
                  <tr>
                    <td>Est. Closing Date</td>
                    <td>{formatDateMDY(data?.loanInfoMeta?.estimatedClosingDate)}</td>
                  </tr>
                  <tr>
                    <td>Estimated Appraised Value</td>
                    <td>$ {data?.salesPrice || "0.00"}</td>
                  </tr>
                  <tr>
                    <td>
                      New Loan Amount
                    </td>
                    <td>$ {formatCurrency(data.loanInfoMeta?.amount)}</td>
                  </tr>
                  <tr>
                    <td>
                       Existing Loan Balance</td>
                    <td>$ {formatCurrency(data.loanInfoMeta?.totalloansToBePaid)}</td>
                  </tr> 
                  <tr>
                    <td>
                      {data?.totalClosingMeta?.totalInvestmentText ||
                        "Cash To Borrower"}
                    </td>
                    <td
                      className={
                        (data?.totalClosingMeta?.totalInvestment ?? 0) < 0
                          ? "text-red-600"
                          : ""
                      }
                    >
                      ${" "}
                      {formatCurrency(data?.totalClosingMeta?.totalInvestment)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="tbl-type-a popup-tbl-td-width">
              <h3>Closing Costs</h3>
              <div>
                <table cellPadding="0" cellSpacing="0">
                  <tbody>
                    <tr>
                      <td>Prepaid Costs</td>
                      <td>
                        $ {formatCurrency(data.totalClosingMeta?.totalPrepaids)}
                      </td>
                    </tr>
                    <tr>
                      <td>Total Closing Costs</td>
                      <td>
                        ${" "}
                        {formatCurrency(
                          data.totalClosingMeta?.totalClosingCosts,
                        )}
                      </td>
                    </tr>
                   {/*  <tr>
                      <td>Down Payment</td>
                      <td>
                        $ {formatCurrency(data.loanInfoMeta?.buyerDownPayment)}
                      </td>
                    </tr> 
                    <tr>
                      <td>Estimated Tax Prorations</td>
                      <td>
                        ${" "}
                        {formatCurrency(
                          data.paymentMeta?.estimatedTaxProrations,
                        )}
                      </td>
                    </tr>*/}
                    <tr>
                      <td>
                        <b>
                          {data?.totalClosingMeta?.totalInvestmentText ||
                            "Cash To Borrower"}
                        </b>
                      </td>
                      <td>
                        <b
                          className={
                            (data?.totalClosingMeta?.totalInvestment ?? 0) < 0
                              ? "text-red-600"
                              : ""
                          }
                        >
                          ${" "}
                          {formatCurrency(
                            data.totalClosingMeta?.totalInvestment,
                          )}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="tbl-type-a popup-tbl-td-width">
              <h3>Monthly Payment Info</h3>
              <div>
                <table cellPadding="0" cellSpacing="0">
                  <tbody>
                    <tr>
                      <td>Principal and Interest</td>
                      <td>
                        ${" "}
                        {formatCurrency(data.paymentMeta?.principalAndInterest)}
                      </td>
                    </tr>
                    <tr>
                      <td>Real Estate Taxes</td>
                      <td>
                        $ {formatCurrency(data.paymentMeta?.realEstateTaxes)}
                      </td>
                    </tr>
                    <tr>
                      <td>Home Owner Insurance</td>
                      <td>
                        $ {formatCurrency(data.paymentMeta?.homeownerInsurance)}
                      </td>
                    </tr>
                    <tr>
                      <td>Monthly M.I.P</td>
                      <td>
                        ${" "}
                        {formatCurrency(data.paymentMeta?.rateMonthlyPMIAmount)}
                      </td>
                    </tr>
                    <tr>
                      <td>P & I 2nd TD</td>
                      <td>
                        $ {formatCurrency(data.paymentMeta?.pAndI2ndTDAmount)}
                      </td>
                    </tr>
                    <tr>
                      <td>{data.paymentMeta?.monthlyExpense1}</td>
                      <td>
                        ${" "}
                        {formatCurrency(
                          data.paymentMeta?.monthlyExpense1Amount,
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>{data.paymentMeta?.monthlyExpense2}</td>
                      <td>
                        ${" "}
                        {formatCurrency(
                          data.paymentMeta?.monthlyExpense2Amount,
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <b>Total Payment (PITI)</b>
                      </td>
                      <td>
                        <b>
                          ${" "}
                          {formatCurrency(
                            data.totalClosingMeta?.totalMonthlyPayment,
                          )}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="tbl-type-a popup-tbl-td-width">
              <h3>Fixed Closing Costs</h3>
              <div>
                <table cellPadding="0" cellSpacing="0">
                  <tbody>
                    <tr>
                      <td>Escrow or Settlement</td>
                      <td>
                        ${" "}
                        {formatCurrency(
                          data?.titleSettlementMeta?.escrowSettlementAmount,
                        ) || "0.00"}
                      </td>
                    </tr>
                    <tr>
                      <td>Title Insurance</td>
                      <td>
                        ${" "}
                        {formatCurrency(
                          data?.titleSettlementMeta?.ownersTitleAmount,
                        ) || "0.00"}
                      </td>
                    </tr>                   

                    {data?.buyerClosingCostsMeta?.length > 0 ? (
                      data.buyerClosingCostsMeta?.map((item, index) => (
                        <tr key={index}>
                          <td>{item.label || "—"}</td>
                          <td>
                            {getBuyerClosingCostUnit(item)}{" "}
                            {formatCurrency(getBuyerClosingCostValue(item))}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="2">No Fixed Costs Available</td>
                      </tr>
                    )}

                    {data?.closingCostsMeta?.length > 0 ? (
                      data.closingCostsMeta?.map((item, index) => (
                        <tr key={index}>
                          <td>{item.label || "—"}</td>
                          <td>
                            {"$"} {formatCurrency(item.value || 0)}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="2">No Fixed Costs Available</td>
                      </tr>
                    )}

                    <tr>
                      <td>
                        <b>Total Fixed Costs</b>
                      </td>
                      <td>
                        <b>
                          ${" "}
                          {formatCurrency(
                            data?.totalClosingMeta?.totalClosingCosts || 0,
                          )}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="model-footer">
            <div className="model-popup-button-fixed next-step-btn">
              <button
                className="submit-btn btn-bg inpt-btn"
                onClick={() => setStep(2)}
              >
                Next
              </button>
            </div>
          </div>
        </>
      ) : (
        <div className="model-body">
          <div className="model-popup-style">
            <div className="requiredlist-md">
              <ul>
                <li className="icon-requiredlist reqlst-edit">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      handleClose();
                      setTimeout(() => {
                        onEditManual();
                      }, 100);
                    }}
                  >
                    Open and edit the sheet manually
                  </button>
                </li>

                <li className="icon-requiredlist reqlst-download">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      handleDownloadPrintPDF("download", data);
                    }}
                  >
                    Download this sheet
                  </button>
                </li>
                <li className="icon-requiredlist reqlst-print">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      handleDownloadPrintPDF("print", data);
                    }}
                  >
                    Print this sheet
                  </button>
                </li>
                <li className="icon-requiredlist reqlst-email">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      const user = JSON.parse(localStorage.getItem("user"));
                      // Not `data` (the frozen prop from whenever this modal
                      // was first opened) — same stale-closure risk as
                      // Download/Print, plus this ensures the origination-fee
                      // row is converted from percent to a dollar amount even
                      // if ManualSheetSection never mounted this session.
                      const updated = buildBuyerPayload({
                        buyerformData: getEffectiveFormData(),
                        user,
                      });
                      openModal({
                        title: "Email a Closing Cost Estimate",
                        size: "mediumsizewidth",
                        content: (
                          <EmailModal
                            onClose={cancelResultModal}
                            type="buyer"
                            showToaster={showToaster}
                            buyerFormData={updated}
                          />
                        ),
                      });
                    }}
                  >
                    Email this sheet
                  </button>
                </li>
                {!isGuestUser(user) && (
                  <li className="icon-requiredlist reqlst-save">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        handleSaveCalc();
                      }}
                    >
                      Save sheet to be accessed later
                    </button>
                  </li>
                )}
                <li className="icon-requiredlist reqlst-cancel">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      cancelModal();
                    }}
                  >
                    Cancel
                  </button>
                </li>
                <li className="icon-requiredlist reqlst-exit">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      handleExit(e);
                    }}
                  >
                    Exit
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
